import React from "react";
import {
  FlexRowBetween,
  MediumFont,
  PopupForm,
  TextWithPic,
} from "../../common/Style";
import { useHistory } from "react-router-dom";

import ClientRoutes from "../../../navigation/Routes";

const Support = ({ sP, uPphone }) => {
  let history = useHistory();

  return (
    <PopupForm onClick={(e) => e.stopPropagation()}>
      <div
        style={{
          width: "90%",
          margin: "15px auto",
        }}
      >
        <MediumFont>
          לכל שאלה בנושא אישורי ההגעה יש תשובה בעמוד ההדרכות
        </MediumFont>
        <div>
          במידה ולא מצאתם תשובה בעמוד ההדרכות יש לפנות לתמיכה הטכנית בלחיצה על
          הכפתור הווצאפ מתחת להודעה זו
        </div>
        <FlexRowBetween style={{ marginTop: "15px" }}>
          <a
            onClick={(e) => e.stopPropagation()}
            style={{
              textDecoration: "none",
              color: "#3a3c3f",
            }}
            target="_blank"
            rel="noreferrer"
            href={`https://wa.me/972${sP}/?text=היי, ברצוני לקבל תמיכה טכנית, מספר הטלפון של אירוע זה הינו: ${uPphone}`}
          >
            <TextWithPic style={{ width: "max-content" }}>
              מעבר לווצאפ
            </TextWithPic>
          </a>
          <a
            onClick={(e) => e.stopPropagation()}
            style={{
              textDecoration: "none",
              color: "#3a3c3f",
            }}
            target="_blank"
            rel="noreferrer"
            href={`tel:0${sP}`}
          >
            <TextWithPic style={{ width: "max-content" }}>חיוג</TextWithPic>
          </a>
          <TextWithPic
            style={{ width: "max-content" }}
            onClick={() => history.push(ClientRoutes.User.instruction)}
          >
            מעבר להדרכות
          </TextWithPic>
        </FlexRowBetween>
        <MediumFont style={{ marginTop: "20px" }}>
          במידה וצריכים עזרה בנושא הושבה יש לפנות ישירות למנהל ההושבה שלכם ולא
          לתמיכה טכנית לאישורי הגעה
        </MediumFont>
      </div>
    </PopupForm>
  );
};

export default Support;
